<!--============================
=            WIZARD            =
=============================-->
<template>
  <!-- Forms Wizard -->
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Wizard</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <!-- Forms Wizard -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Playground Wizard
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div class="pa-10">
              <v-row justify="space-around">
                <v-col cols="12">
                  <v-slider
                    v-model="steps"
                    label="Steps"
                    min="2"
                    max="20"
                  ></v-slider>
                </v-col>
                <v-switch v-model="vertical" label="Vertical"></v-switch>
                <v-switch v-model="altLabels" label="altLabels"></v-switch>
                <v-switch v-model="editable" label="Editable"></v-switch>
              </v-row>
              <v-stepper
                v-model="e1"
                :vertical="vertical"
                :alt-labels="altLabels"
              >
                <template v-if="vertical">
                  <template v-for="n in steps">
                    <v-stepper-step
                      :key="`${n}-step`"
                      :complete="e1 > n"
                      :step="n"
                      :editable="editable"
                      >Step {{ n }}
                    </v-stepper-step>

                    <v-stepper-content :key="`${n}-content`" :step="n">
                      <v-card
                        class="mb-12"
                        color="grey lighten-1"
                        height="200px"
                      ></v-card>

                      <v-btn color="primary" @click="nextStep(n)"
                        >Continue</v-btn
                      >

                      <v-btn text>Cancel</v-btn>
                    </v-stepper-content>
                  </template>
                </template>
                <template v-else>
                  <v-stepper-header>
                    <template v-for="n in steps">
                      <v-stepper-step
                        :key="`${n}-step`"
                        :complete="e1 > n"
                        :step="n"
                        :editable="editable"
                        >Step {{ n }}
                      </v-stepper-step>

                      <v-divider v-if="n !== steps" :key="n"></v-divider>
                    </template>
                  </v-stepper-header>

                  <v-stepper-items>
                    <v-stepper-content
                      v-for="n in steps"
                      :key="`${n}-content`"
                      :step="n"
                    >
                      <v-card
                        class="mb-12"
                        color="grey lighten-1"
                        height="200px"
                      ></v-card>

                      <v-btn color="primary" @click="nextStep(n)"
                        >Continue</v-btn
                      >

                      <v-btn text>Cancel</v-btn>
                    </v-stepper-content>
                  </v-stepper-items>
                </template>
              </v-stepper>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- Forms Wizard -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Editable steps
            <div class="textt">
              An editable step can be selected by a user at any point and will
              navigate them to that step.
            </div>
          </div>
          <div slot="card-body">
            <div class="pa-10">
              <v-stepper>
                <v-stepper-header>
                  <v-stepper-step complete editable step="1"
                    >Select campaign settings</v-stepper-step
                  >

                  <v-divider></v-divider>

                  <v-stepper-step complete step="2"
                    >Create an ad group</v-stepper-step
                  >

                  <v-divider></v-divider>

                  <v-stepper-step step="3" editable
                    >Create an ad</v-stepper-step
                  >
                </v-stepper-header>
              </v-stepper>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- Forms Wizard -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Non-editable steps
            <div class="textt">
              Non-editable steps force a user to process linearly through your
              process.
            </div>
          </div>
          <div slot="card-body">
            <div class="pa-10">
              <v-stepper value="2">
                <v-stepper-header>
                  <v-stepper-step step="1" complete
                    >Select campaign settings</v-stepper-step
                  >

                  <v-divider></v-divider>

                  <v-stepper-step step="2">Create an ad group</v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step step="3">Create an ad</v-stepper-step>
                </v-stepper-header>
              </v-stepper>
            </div>
          </div>
        </base-card>
      </v-col>

      <!-- Forms Wizard -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Optional steps
            <div class="textt">
              An optional step can be called out with sub-text.
            </div>
          </div>
          <div slot="card-body">
            <div class="pa-10">
              <v-stepper value="1">
                <v-stepper-header>
                  <v-stepper-step step="1"
                    >Select campaign settings</v-stepper-step
                  >

                  <v-divider></v-divider>

                  <v-stepper-step step="2">
                    Create an ad group
                    <small>Optional</small>
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step step="3">Create an ad</v-stepper-step>
                </v-stepper-header>
              </v-stepper>

              <v-stepper value="2" class="mt-12">
                <v-stepper-header>
                  <v-stepper-step step="1" complete
                    >Select campaign settings</v-stepper-step
                  >

                  <v-divider></v-divider>

                  <v-stepper-step step="2">
                    Create an ad group
                    <small>Optional</small>
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step step="3">Create an ad</v-stepper-step>
                </v-stepper-header>
              </v-stepper>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- Forms Wizard -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Horizontal steps
            <div class="textt">
              Horizontal steppers move users along the x-axis through the
              defined steps.
            </div>
          </div>
          <div slot="card-body">
            <div class="pa-10">
              <v-stepper value="1">
                <v-stepper-header>
                  <v-stepper-step step="1"
                    >Select campaign settings</v-stepper-step
                  >

                  <v-divider></v-divider>

                  <v-stepper-step step="2">Create an ad group</v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step step="3">Create an ad</v-stepper-step>
                </v-stepper-header>
              </v-stepper>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- Forms Wizard -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Vertical steppers
            <div class="pa-10">
              Vertical steppers move users along the y-axis and otherwise work
              exactly the same as their horizontal counterpart.
            </div>
          </div>
          <div slot="card-body">
            <div class="pa-10">
              <v-stepper v-model="e6" vertical>
                <v-stepper-step :complete="e6 > 1" step="1">
                  Select an app
                  <small>Summarize if needed</small>
                </v-stepper-step>

                <v-stepper-content step="1">
                  <v-card
                    color="grey lighten-1"
                    class="mb-12"
                    height="200px"
                  ></v-card>
                  <v-btn color="primary" @click="e6 = 2">Continue</v-btn>
                  <v-btn text>Cancel</v-btn>
                </v-stepper-content>

                <v-stepper-step :complete="e6 > 2" step="2"
                  >Configure analytics for this app</v-stepper-step
                >

                <v-stepper-content step="2">
                  <v-card
                    color="grey lighten-1"
                    class="mb-12"
                    height="200px"
                  ></v-card>
                  <v-btn color="primary" @click="e6 = 3">Continue</v-btn>
                  <v-btn text>Cancel</v-btn>
                </v-stepper-content>

                <v-stepper-step :complete="e6 > 3" step="3"
                  >Select an ad format and name ad unit</v-stepper-step
                >

                <v-stepper-content step="3">
                  <v-card
                    color="grey lighten-1"
                    class="mb-12"
                    height="200px"
                  ></v-card>
                  <v-btn color="primary" @click="e6 = 4">Continue</v-btn>
                  <v-btn text>Cancel</v-btn>
                </v-stepper-content>

                <v-stepper-step step="4"
                  >View setup instructions</v-stepper-step
                >
                <v-stepper-content step="4">
                  <v-card
                    color="grey lighten-1"
                    class="mb-12"
                    height="200px"
                  ></v-card>
                  <v-btn color="primary" @click="e6 = 1">Continue</v-btn>
                  <v-btn text>Cancel</v-btn>
                </v-stepper-content>
              </v-stepper>
            </div>
          </div>
        </base-card>
      </v-col>

      <!-- Forms Wizard -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Linear steppers
            <div class="textt">
              Linear steppers will always move a user through your defined path.
            </div>
          </div>
          <div slot="card-body">
            <div class="pa-10">
              <v-stepper>
                <v-stepper-header>
                  <v-stepper-step step="1"
                    >Select campaign settings</v-stepper-step
                  >

                  <v-divider></v-divider>

                  <v-stepper-step step="2">Create an ad group</v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step step="3">Create an ad</v-stepper-step>
                </v-stepper-header>
              </v-stepper>

              <v-stepper value="2" class="mt-12">
                <v-stepper-header>
                  <v-stepper-step step="1" complete
                    >Select campaign settings</v-stepper-step
                  >

                  <v-divider></v-divider>

                  <v-stepper-step step="2">Create an ad group</v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step step="3">Create an ad</v-stepper-step>
                </v-stepper-header>
              </v-stepper>

              <v-stepper value="3" class="mt-12">
                <v-stepper-header>
                  <v-stepper-step step="1" complete
                    >Select campaign settings</v-stepper-step
                  >

                  <v-divider></v-divider>

                  <v-stepper-step step="2" complete
                    >Create an ad group</v-stepper-step
                  >

                  <v-divider></v-divider>

                  <v-stepper-step step="3">Create an ad</v-stepper-step>
                </v-stepper-header>
              </v-stepper>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- Forms Wizard -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Non-linear steppers
            <div class="textt">
              Non-linear steppers allow the user to move through your process in
              whatever way they choose.
            </div>
          </div>
          <div slot="card-body">
            <div class="pa-10">
              <v-stepper non-linear>
                <v-stepper-header>
                  <v-stepper-step editable step="1"
                    >Select campaign settings</v-stepper-step
                  >

                  <v-divider></v-divider>

                  <v-stepper-step editable step="2"
                    >Create an ad group</v-stepper-step
                  >

                  <v-divider></v-divider>

                  <v-stepper-step step="3" editable
                    >Create an ad</v-stepper-step
                  >
                </v-stepper-header>
              </v-stepper>

              <v-stepper class="mt-12" non-linear>
                <v-stepper-header>
                  <v-stepper-step complete editable step="1"
                    >Select campaign settings</v-stepper-step
                  >

                  <v-divider></v-divider>

                  <v-stepper-step editable step="2"
                    >Create an ad group</v-stepper-step
                  >

                  <v-divider></v-divider>

                  <v-stepper-step complete editable step="3"
                    >Create an ad</v-stepper-step
                  >
                </v-stepper-header>
              </v-stepper>

              <v-stepper class="mt-12" non-linear value="3">
                <v-stepper-header>
                  <v-stepper-step complete editable step="1"
                    >Select campaign settings</v-stepper-step
                  >

                  <v-divider></v-divider>

                  <v-stepper-step complete editable step="2"
                    >Create an ad group</v-stepper-step
                  >

                  <v-divider></v-divider>

                  <v-stepper-step complete editable step="3"
                    >Create an ad</v-stepper-step
                  >
                </v-stepper-header>
              </v-stepper>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- Forms Wizard -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Alternate labels
            <div class="textt">
              Steppers also have an alternative label style which places the
              title under the step itself.
            </div>
          </div>
          <div slot="card-body">
            <div class="pa-10">
              <v-stepper alt-labels>
                <v-stepper-header>
                  <v-stepper-step step="1">Ad unit details</v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step step="2">Ad sizes</v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step step="3">Ad templates</v-stepper-step>
                </v-stepper-header>
              </v-stepper>

              <v-stepper alt-labels class="mt-12">
                <v-stepper-header>
                  <v-stepper-step step="1">Ad unit details</v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step step="2">
                    Ad sizes
                    <small>Optional</small>
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step step="3">Ad templates</v-stepper-step>
                </v-stepper-header>
              </v-stepper>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- Forms Wizard -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Multi-line error state
            <div class="textt">
              An error state can be displayed to notify the user of some action
              that must be taken.
            </div>
          </div>
          <div slot="card-body">
            <div class="pa-10">
              <v-stepper>
                <v-stepper-header>
                  <v-stepper-step step="1">Ad unit details</v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step :rules="[() => false]" step="2">
                    Ad templates
                    <small>Alert message</small>
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step step="3">Ad sizes</v-stepper-step>
                </v-stepper-header>
              </v-stepper>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- Forms Wizard -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Alternative label multi-line error state
            <div class="textt">
              The error state can also be applied to the alternative label
              style.
            </div>
          </div>
          <div slot="card-body">
            <div class="pa-10">
              <v-stepper alt-labels>
                <v-stepper-header>
                  <v-stepper-step step="3" complete>Ad type</v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step step="4" complete>Ad style</v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step :rules="[() => false]" step="5">
                    Custom channels
                    <small>Alert message</small>
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step step="6">Get code</v-stepper-step>
                </v-stepper-header>
              </v-stepper>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- Forms Wizard -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Vertical multi-line error state
            <div class="textt">
              The same state also applies to Vertical steppers.
            </div>
          </div>
          <div slot="card-body">
            <div class="pa-10">
              <v-stepper v-model="e13" vertical>
                <v-stepper-step step="1" complete
                  >Name of step 1</v-stepper-step
                >

                <v-stepper-content step="1">
                  <v-card
                    color="grey lighten-1"
                    class="mb-12"
                    height="200px"
                  ></v-card>
                  <v-btn color="primary" @click="e13 = 2">Continue</v-btn>
                  <v-btn text>Cancel</v-btn>
                </v-stepper-content>

                <v-stepper-step step="2" complete
                  >Name of step 2</v-stepper-step
                >

                <v-stepper-content step="2">
                  <v-card
                    color="grey lighten-1"
                    class="mb-12"
                    height="200px"
                  ></v-card>
                  <v-btn color="primary" @click="e13 = 3">Continue</v-btn>
                  <v-btn text>Cancel</v-btn>
                </v-stepper-content>

                <v-stepper-step :rules="[() => false]" step="3">
                  Ad templates
                  <small>Alert message</small>
                </v-stepper-step>

                <v-stepper-content step="3">
                  <v-card
                    color="grey lighten-1"
                    class="mb-12"
                    height="200px"
                  ></v-card>
                  <v-btn color="primary" @click="e13 = 4">Continue</v-btn>
                  <v-btn text>Cancel</v-btn>
                </v-stepper-content>

                <v-stepper-step step="4"
                  >View setup instructions</v-stepper-step
                >

                <v-stepper-content step="4">
                  <v-card
                    color="grey lighten-1"
                    class="mb-12"
                    height="200px"
                  ></v-card>
                  <v-btn color="primary" @click="e13 = 1">Continue</v-btn>
                  <v-btn text>Cancel</v-btn>
                </v-stepper-content>
              </v-stepper>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- Forms Wizard -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Dynamic steps
            <div class="textt">
              Steppers can have their steps dynamically added or removed. If a
              currently active step is removed, be sure to account for this by
              changing the applied model.
            </div>
          </div>
          <div slot="card-body">
            <div class="pa-10">
              <v-card class="mb-4">
                <v-card-text>
                  <v-select
                    v-model="steps"
                    :items="[2, 3, 4, 5, 6]"
                    label="# of steps"
                  ></v-select>
                </v-card-text>
              </v-card>
              <v-stepper v-model="e1">
                <v-stepper-header>
                  <template v-for="n in steps">
                    <v-stepper-step
                      :key="`${n}-step`"
                      :complete="e1 > n"
                      :step="n"
                      editable
                      >Step {{ n }}
                    </v-stepper-step>

                    <v-divider v-if="n !== steps" :key="n"></v-divider>
                  </template>
                </v-stepper-header>

                <v-stepper-items>
                  <v-stepper-content
                    v-for="n in steps"
                    :key="`${n}-content`"
                    :step="n"
                  >
                    <v-card
                      class="mb-12"
                      color="grey lighten-1"
                      height="200px"
                    ></v-card>

                    <v-btn color="primary" @click="nextStep(n)">Continue</v-btn>

                    <v-btn text>Cancel</v-btn>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
  components: {
    BaseCard,
    BaseHeader
  },

  data() {
    return {
      e6: 1,
      e1: 1,
      steps: 2,
      vertical: false,
      altLabels: false,
      editable: true
    };
  },

  watch: {
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val;
      }
    },
    vertical() {
      this.e1 = 2;
      requestAnimationFrame(() => (this.e1 = 1)); // Workarounds
    }
  },

  methods: {
    onInput(val) {
      this.steps = parseInt(val);
    },
    nextStep(n) {
      if (n === this.steps) {
        this.e1 = 1;
      } else {
        this.e1 = n + 1;
      }
    }
  }
};
</script>

<!--====  End of WIZARD  ====-->
